"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Form codes and patient-link codes are bearer credentials: whoever has the
 * link can open the form or the patient's chat. These keep them out of the
 * URLs and messages sent to Sentry and PostHog. */



const CODES = [
  [/\/form\/F[a-z0-9]{11}/gi, '/form/F[code]'],
  [/\/forms\/sent\/F?[a-z0-9]{11}/gi, '/forms/sent/[code]'],
  [/\/conversation\/[a-zA-Z0-9]{12}/g, '/conversation/[code]'],
]

 const redactLinks = (text) =>
  CODES.reduce((out, [pattern, replacement]) => out.replace(pattern, replacement), text); exports.redactLinks = redactLinks

const redactValues = (values) => {
  if (!values) return values
  const out = {}
  Object.entries(values).forEach(([key, value]) => { out[key] = typeof value === 'string' ? exports.redactLinks.call(void 0, value) : value })
  return out 
}

/* Sentry's beforeSend: the request URL and referrer, the transaction name,
 * exception messages, breadcrumbs, and the string values of extra and each
 * context. */
 const redactSentryEvent = (event) => {
  if (event.request) {
    event.request.url = event.request.url && exports.redactLinks.call(void 0, event.request.url)
    event.request.headers = redactValues(event.request.headers)
  }
  if (event.transaction) event.transaction = exports.redactLinks.call(void 0, event.transaction)
  if (event.message) event.message = exports.redactLinks.call(void 0, event.message)
  _optionalChain([event, 'access', _ => _.exception, 'optionalAccess', _2 => _2.values, 'optionalAccess', _3 => _3.forEach, 'call', _4 => _4(exception => {
    if (exception.value) exception.value = exports.redactLinks.call(void 0, exception.value)
  })])
  event.extra = redactValues(event.extra)
  if (event.contexts) {
    event.contexts = Object.fromEntries(Object.entries(event.contexts)
      .map(([name, context]) => [name, redactValues(_nullishCoalesce(context, () => ( undefined)))]))
  }
  event.breadcrumbs = _optionalChain([event, 'access', _5 => _5.breadcrumbs, 'optionalAccess', _6 => _6.map, 'call', _7 => _7(crumb => ({
    ...crumb,
    ...(crumb.message ? { message: exports.redactLinks.call(void 0, crumb.message) } : {}),
    ...(crumb.data ? { data: redactValues(crumb.data) } : {}),
  }))])
  return event
}; exports.redactSentryEvent = redactSentryEvent

/* PostHog's before_send: $current_url, $pathname, $referrer and every other
 * string property, including the person properties it sets. */
 const redactPostHogEvent = (event) => {
  if (!event) return event
  return {
    ...event,
    properties: redactValues(event.properties),
    ...(event.$set ? { $set: redactValues(event.$set) } : {}),
    ...(event.$set_once ? { $set_once: redactValues(event.$set_once) } : {}),
  }
}; exports.redactPostHogEvent = redactPostHogEvent
